import { render, staticRenderFns } from "./Wafer.vue?vue&type=template&id=7717f4e2&scoped=true&"
import script from "./Wafer.vue?vue&type=script&lang=js&"
export * from "./Wafer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7717f4e2",
  null
  
)

export default component.exports